import { useState, useEffect } from 'react';
import styled from '@emotion/styled'

import { Grid, Card, Button, TextField } from '@mui/material'

import { Panel, SwitchSection, Section, HebrewSpan, TagField, TagRuleDescription, ErrorList, TagRules, validateTemplate } from '../../Common'

import { usePageData } from '../../../../contexts/PageData';

import { BasicFlex } from '../../../../utils/Common';



const GeneralTab = () => {

  return (
    <Panel>

      <SwitchSection title="Display Invoice totals" description="On the invoice page, display totals at the top" switchName="display_invoice_totals" />

      <SwitchSection title="Display Payment totals" description="On the payment page, display totals at the top" switchName="display_payment_totals" />

      <SwitchSection title="Display Sold Wigs totals" description="On the sold wigs page, display totals at the top" switchName="display_sold_wigs_totals" />
     
    </Panel>
  )
};

export default GeneralTab;

// update system settings
// INSERT INTO settings (
//   system_id, resource, resource_tab, settings_level,
//   override_user, data, user_id, "timestamp"
// )
// SELECT
//   s.system_id,
//   'general',
//   'general',
//   'system',
//   true,
//   '{
//     "display_invoice_totals": true,
//     "display_payment_totals": true,
//     "display_sold_wigs_totals": true
//   }'::jsonb,
//   NULL,
//   now()
// FROM systems s
// WHERE NOT EXISTS (
//   SELECT 1 FROM settings st
//   WHERE st.system_id = s.system_id
//     AND st.resource = 'general'
//     AND st.resource_tab = 'general'
//     AND st.settings_level = 'system'
//     AND st.user_id IS NULL
// );